import React from 'react';
import { FOOTER_LINKS } from './constants';
import {
  Container,
  FooterLink,
  FooterRoot,
  LegalSection,
  LinkGroup,
  PhoneNumber,
  Text,
} from './styles';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterRoot role="contentinfo">
      <Container>
        <LegalSection>
          <LinkGroup aria-label="Legal and policies">
            {FOOTER_LINKS.map(({ href, text }) => (
              <FooterLink href={href} key={`referral-footer-${text}`}>
                {text}
              </FooterLink>
            ))}
          </LinkGroup>

          <Text>
            Yes, we have to include some legalese down here. Policygenius LLC (DBA Policygenius
            Insurance Services in California) (“Policygenius”), a Delaware corporation with its
            principal place of business in Greenwich, Connecticut, is a licensed independent
            insurance broker. The information provided on this site has been developed by
            Policygenius for general informational and educational purposes. We do our best to
            ensure that this information is up-to-date and accurate. Any insurance policy premium
            quotes or ranges displayed are non-binding. The final insurance policy premium for any
            policy is determined by the underwriting insurance company following application.
          </Text>
          <Text>
            If you are using a screen reader and are having problems using this website, please call{' '}
            <PhoneNumber href="tel:1-855-695-2255">1-855-695-2255</PhoneNumber> for assistance.
          </Text>
          <Text>Copyright Policygenius © 2014-{currentYear}. All Rights Reserved.</Text>
        </LegalSection>
      </Container>
    </FooterRoot>
  );
};

export default Footer;
